import React from 'react';
import { Outlet } from 'react-router-dom';

import './CardWithdrawal.scss';

const CardWithdrawal = () => {
	return (
		<div className='CardWithdrawal'>
			<Outlet />
		</div>
	);
};

export default CardWithdrawal;
